import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../../context/user';
import { useSignOut } from '../../hooks/useSignOut';
import { getDefaultPage } from '../../helpers/permissions';
import AccessDeniedLayout from '../../layouts/AccessDeniedLayout';

const RoleBasedRedirect: React.FC = () => {
    const { jwtToken, isLoadingProfile, isFetchingSetup, profile, setIsLoadingProfile } = useUserContext();
    const [redirectPath, setRedirectPath] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true)
    const profileRetryRef = React.useRef(false);

    const signOut = useSignOut();

    useEffect(() => {
        /*
        Редирект автоматически срабатывает сразу после авторизации,
        но т.к мы после авторизации инициировали загрузку профиля
        то нужно дождаться ее окончания
         */
        if (isLoadingProfile || isFetchingSetup) {
            setIsLoading(true);
            return;
        }

        if (!jwtToken) {
            setRedirectPath('/sign_in/refresh_token');
            setIsLoading(false);
        } else if (profile) {
            profileRetryRef.current = false;
            // null означает, что идти некуда — ниже покажем экран отказа,
            // а не редирект на "/", который замыкается сам на себя
            const page = getDefaultPage(profile.permissions, profile.role)
            setRedirectPath(page);
            setIsLoading(false);
        } else if (!profileRetryRef.current) {
            // Токен уже есть, но профиль ещё не загрузился
            profileRetryRef.current = true;
            setIsLoading(true);
            setIsLoadingProfile(true);
        } else {
            setIsLoading(false);
        }
    }, [jwtToken, profile, isLoadingProfile, isFetchingSetup, setIsLoadingProfile]);

    if (redirectPath) {
        return <Navigate to={redirectPath} replace />;
    }

    if (isLoading) {
        return <div className='flex justify-center items-center h-screen'>
            <img src="/icons/logo.png" alt="logo" className="w-10 aspect-square ml-4"></img>
        </div>;
    }

    // Сюда попадаем в двух случаях: профиль не загрузился совсем либо загрузился,
    // но ни один раздел пользователю не доступен. Раньше второй случай уводил
    // в редирект на "/" и давал белый экран (ALX-59538, ALX-59896)
    const noAccessMsg = profile
        ? `
    Ни один раздел админ-панели вам не доступен.
     Обратитесь к администратору за правами доступа
    `
        : `
    Не удается получить информацию о профиле
     или профиль с неизвестной ролью
    `

    return <AccessDeniedLayout
        message={noAccessMsg}
        onSignOut={signOut}
    />;
};

export default RoleBasedRedirect;


